import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
	EmbeddedCheckoutProvider,
	EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import Store from '../../store/Store';

const stripePromise = loadStripe(
	'pk_test_51QoLHgH2EpTdrVFYhfkDnzjEWcOVftwAJcgPppAjinbbhLtgTieym8ML1kjhP49riUSAIFBkTsa6vxJ2TRXZgecN003mhFa3dD'
);

export interface CheckoutFormProps {
	productKey: string;
	orderId: string;
	onPaymentSuccess?: () => void;
	returnParam?: string;
}

export default function CheckoutForm({
	productKey,
	orderId,
	onPaymentSuccess,
	returnParam,
}: CheckoutFormProps) {
	const [clientSecret, setClientSecret] = useState('');

	useEffect(() => {
		Store.checkoutOrder(orderId, returnParam).then((data: { clientSecret?: string }) => {
			if (data?.clientSecret) {
				setClientSecret(data.clientSecret);
			} else {
				console.error('Fehler beim Abrufen des Client Secrets');
			}
		});
	}, [productKey, orderId, returnParam]);

	if (!clientSecret) return null;

	return (
		<div className="checkout">
			<EmbeddedCheckoutProvider
				stripe={stripePromise}
				options={{
					clientSecret,
					onComplete: () => {
						console.log('Payment completed');
						onPaymentSuccess?.();
					},
				}}
			>
				<EmbeddedCheckout />
			</EmbeddedCheckoutProvider>
		</div>
	);
}